var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";

var WidgetTab = (_temp2 = _class = function (_Component) {
    _inherits(WidgetTab, _Component);

    function WidgetTab() {
        var _temp, _this, _ret;

        _classCallCheck(this, WidgetTab);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getStyle = function () {
            var _this$props = _this.props,
                selected = _this$props.selected,
                theme = _this$props.theme;


            if (!selected) {
                return {};
            }

            return {
                borderColor: theme.primaryColor || "black"
            };

            var style = {};
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    WidgetTab.prototype.render = function render() {
        var _props = this.props,
            selected = _props.selected,
            onClick = _props.onClick;


        var style = this.getStyle();

        return React.createElement(
            "div",
            { className: "admin-widget__tab", style: style, "aria-selected": selected, onClick: onClick },
            this.props.children
        );
    };

    return WidgetTab;
}(Component), _class.defaultProps = {
    theme: {
        primaryColor: "black"
    },
    selected: false
}, _temp2);
WidgetTab.propTypes = process.env.NODE_ENV !== "production" ? {
    selected: PropTypes.bool
} : {};


export default WidgetTab;